import React from 'react'
import QCADIconV2 from './qcad_logo_v2.png'

export const QCADIcon: React.FC<{ size?: number }> = ({ size = 24 }) => (
  <img
    src={QCADIconV2}
    alt="icon"
    style={{
      width: size,
      height: size,
      display: 'inline-block'
    }}
  />
)
